import File02 from '@untitled-ui/icons-react/build/esm/File02';

import { Tooltip } from 'antd';
import { useLazyGetStatusReportPdfQuery } from 'api/IndividualsApiSlice';
import { useToast } from 'providers/ToastProvider';
import { BaseButton } from './BaseButton';

interface RecordType {
  lastKycId?: string;
  lastKycFlowId?: string;
  firstName?: string;
  lastName?: string;
  status?: string;
}

interface DownloadPdfButtonProps {
  record: RecordType;
}

export const DownloadPdfButton = ({ record }: DownloadPdfButtonProps) => {
  const [getStatusReportPdf, { isFetching }] = useLazyGetStatusReportPdfQuery();
  const toast = useToast();

  if (record?.status === 'InProgress' || record?.status === 'Expired') {
    return null;
  }

  const handleDownloadPdf = async () => {
    const kycFlowId = record?.lastKycFlowId ?? record?.lastKycId;

    if (!kycFlowId) {
      toast.warning('No verification found for this individual.');
      return;
    }

    try {
      const { blob } = await getStatusReportPdf(kycFlowId).unwrap();

      const personName = [record.firstName, record.lastName].filter(Boolean).join('-');
      const filename = `${personName || 'verification'}-status-report.pdf`;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      toast.error('Failed to download verification PDF.');
    }
  };

  return (
    <Tooltip title="Download Verification PDF">
      <BaseButton
        className="secondary-button min-h-8 min-w-8"
        icon={<File02 className="h-4 w-4" />}
        loading={isFetching}
        onClick={handleDownloadPdf}
      />
    </Tooltip>
  );
};

export default DownloadPdfButton;
